/**
 * Plan names returned by the account API for users who are NOT on a paid subscription.
 * Keep this list in sync with the plan names configured on the backend.
 */
export const FREE_PLAN_NAMES = new Set([
  'free',
  'free account',
  'basic',
  'personal-basic',
  'personal basic'
]);

function normalizePlanName(planName: any): string {
  return (planName ?? '').toString().trim().toLowerCase();
}

export function isFreePlanName(planName: any): boolean {
  const name = normalizePlanName(planName);
  return !name || FREE_PLAN_NAMES.has(name);
}

/**
 * True only when the account is on a known paid plan. Falls back to `false`
 * when the plan is missing or unreadable so paid-only features stay hidden.
 */
export function isPaidPlanName(planName: any): boolean {
  return !isFreePlanName(planName);
}
